import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';

let opts = _.merge(
    {
        parameters: {
            create: {
                options: {
                    insert_new_records: {
                        title: window.i18n.__(
                            'Si une déclinaison de mon fichier n’existe pas dans Sellsy',
                        ),
                        values: [
                            {
                                value: 'Y',
                                label: window.i18n.__('Ajouter la déclinaison'),
                                description: window.i18n.__(
                                    'La déclinaison du fichier est prise en compte et importée dans Sellsy.',
                                ),
                            },
                            {
                                value: 'N',
                                label: window.i18n.__('Ignorer et ne pas ajouter la déclinaison'),
                                description: window.i18n.__(
                                    'La déclinaison du fichier est ignorée et n’est pas importée dans Sellsy.',
                                ),
                            },
                        ],
                    },
                },
            },
            update: {
                options: {
                    update_existing_records: {
                        title: window.i18n.__('Si une déclinaison de mon fichier existe dans Sellsy'),
                        values: [
                            {
                                value: 'Y',
                                label: window.i18n.__('Mettre à jour la déclinaison'),
                                description: window.i18n.__(
                                    'La déclinaison identique du fichier trouvée par rapport au critère de comparaison renseigné est mis à jour dans Sellsy.',
                                ),
                            },
                            {
                                value: 'N',
                                label: window.i18n.__('Ignorer et ne pas mettre à jour la déclinaison'),
                                description: window.i18n.__(
                                    'La déclinaison identique du fichier trouvée par rapport au critère de comparaison renseigné est ignoré et n’est pas mis à jour dans Sellsy.',
                                ),
                            },
                        ],
                    },
                },
            },
        },
        identifiers: {
            'product-variation': {
                title: window.i18n.__('Critère de comparaison pour les déclinaisons produits'),
                multiple: false,
                choices: [
                    {
                        value: 'variation_reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence ou code de la déclinaison produit unique dans le catalogue',
                        ),
                    },
                    {
                        value: 'variation_id',
                        label: window.i18n.__('Identifiant déclinaison produit'),
                        description: window.i18n.__(
                            'Récupéré depuis un export Sellsy ou depuis le catalogue',
                        ),
                    },
                ],
            },
            product: {
                title: window.i18n.__('Critère de comparaison pour les produits'),
                multiple: false,
                choices: [
                    {
                        value: 'product_reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence ou code du produit unique dans le catalogue',
                        ),
                    },
                    {
                        value: 'product_id',
                        label: window.i18n.__('Identifiant produit'),
                        description: window.i18n.__(
                            'Récupéré depuis un export Sellsy ou depuis le catalogue',
                        ),
                    },
                ],
            },
        }
    },
    globalOptions
);

delete(opts.parameters.update.options.overwrite_tags);

export const options = opts;

export const defaultOptions = {
    identifiers: {
        'product-variation': ['variation_reference'],
        product: ['product_reference'],
    },
};
